import React, { useState } from 'react';
import clsx from 'clsx';

import { useSelector } from "react-redux";
import { makeStyles, createTheme, ThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter as Router } from "react-router-dom";

import Drawer               from '@material-ui/core/Drawer';
import AppBar               from '@material-ui/core/AppBar';
import CssBaseline          from '@material-ui/core/CssBaseline';
import Divider              from '@material-ui/core/Divider';
import IconButton           from '@material-ui/core/IconButton';

import {ChevronLeft, Menu as MenuIcon} from "@material-ui/icons";

import {NavigationItems, NavigationMain, NavigationToolbar} from "./Navigation.jsx";
import {getCurrentUser} from "../store/entities/currentUserSlice";
import Selector from "./Selectors/Drawer/Selector";



const drawerWidth = 240;

export default function() {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const currentUser = useSelector(getCurrentUser);
    const handleDrawerOpen = () => setOpen(true);
    const handleDrawerClose = () => {setOpen(false)
      console.log('close')

    };

    return <Router>
        <div className={classes.root}>
            <CssBaseline />

            {/* top navigation bar */}
            <AppBar
                position="fixed"
                color="primary"
                className={clsx(classes.appBar, {
                    [classes.appBarShift]: open,
                })}
            >
                <NavigationToolbar menuOpener={
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="open drawer"
                        onClick={handleDrawerOpen}
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>
                } />
            </AppBar>

            {/* top navigation drawer */}
            <Drawer
                color="primary"
                className={classes.drawer}
                variant="persistent"
                anchor="left"
                open={open}
                classes={{
                    paper: classes.drawerPaper,
                }}
            >
                <div className={classes.drawerHeader}>
                    <IconButton onClick={handleDrawerClose}>
                        <ChevronLeft />
                    </IconButton>
                </div>
                <Divider />
                <NavigationItems onClick={handleDrawerClose} currentUser={currentUser} open={open} />
            </Drawer>

            {/* main content */}
            <main
                className={clsx(classes.content, {
                    [classes.contentShift]: open,
                })}
            >
                <div className={classes.drawerHeader} />
                <NavigationMain />
            </main>

            <Selector />
        </div>
    </Router>;
}



// style of the layout
const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        //background: 'linear-gradient(0deg, #4E4E4E 0%, #B4B4B4 100%)',
        //backgroundAttachment: 'fixed'
    },
    grow: {
        flexGrow: 1,
    },
    link: {
        color: theme.palette.primary.contrastText,
    },
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px + 25px)`,
        marginLeft: drawerWidth,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    // drawerPaper: {
    //     width: drawerWidth,
    // },
    drawerPaper: {
        background: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: 'flex-end',
        "@media (max-width: 400px)": { minHeight: "54px" }
    },
    content: {
        flexGrow: 1,
        paddingTop: theme.spacing(2),
        padding: theme.spacing(1),
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        marginLeft: -drawerWidth,
    }
}));
